import axios from 'axios';
import { Service_API_URL } from "@/config/develop.json";
import router from "@/router/index";
import Vue from 'vue'
import * as dd from "dingtalk-jsapi";
const service = axios.create({
  timeout: 5000 // 超时时间
});
service.defaults.baseURL = Service_API_URL;
service.defaults.headers['X-Emao-TCM-Wap'] = 'appVersion=2.0.0'
service.defaults.headers['staffid'] = '10000'
service.defaults.headers['timestamp'] = new Date().getTime()
service.defaults.headers['nonce'] = Math.random() * new Date().getTime()
service.defaults.headers['signature'] = 'Emao.College'
service.interceptors.request.use(config => {
  return config
}, error => {
  return Promise.reject(error)
})
service.interceptors.response.use((response) => {
  return response;
}, (error) => {
  router.replace({
    path: "\errors"
  })
  return Promise.reject(error)
})
export default service





// WEBPACK FOOTER //
// ./src/utils/http.js